import { useState } from "react";
import { Pencil, Copy, Download, Send } from "lucide-react";
import { STEPS, LABELS, displayValue, buildMessage } from "./steps";
import { whatsappLink } from "../../lib/site";

const MAX_URL = 1900;

export const Summary = ({ answers, onEdit, onReset }) => {
  const [fallback, setFallback] = useState(false);
  const [copied, setCopied] = useState(false);
  const msg = buildMessage(answers);

  const copy = async () => {
    try { await navigator.clipboard.writeText(msg); setCopied(true); } catch (e) { setCopied(false); }
  };
  const download = () => {
    const url = URL.createObjectURL(new Blob([msg.replace(/\*/g, "")], { type: "text/plain;charset=utf-8" }));
    const a = document.createElement("a");
    a.href = url; a.download = `briefing-nexus-${(answers.empresa || "projeto").replace(/\W+/g, "-")}.txt`; a.click();
    URL.revokeObjectURL(url);
  };
  const send = async () => {
    const full = whatsappLink(msg);
    if (full.length <= MAX_URL) { window.open(full, "_blank", "noopener"); return; }
    await copy();
    setFallback(true);
    window.open(whatsappLink(`Olá! Preenchi o briefing de projeto no site da NEXUS (${answers.empresa}). Vou colar as respostas a seguir.`), "_blank", "noopener");
  };

  return (
    <div data-testid="briefing-summary">
      <p className="font-mono text-xs text-gold mb-4">Resumo do briefing</p>
      <h2 className="font-display text-3xl sm:text-5xl font-semibold tracking-[-0.03em] leading-[1.05]">Confira suas respostas.</h2>
      <p className="mt-4 text-[#A7A7AD] leading-relaxed">Este planejamento serve para entendermos sua necessidade. Após o envio, avaliamos o projeto e retornamos pelo WhatsApp — não há orçamento automático.</p>
      <dl className="mt-10 border-t border-white/10">
        {STEPS.map((s, i) => (
          <div key={s.key} className="grid grid-cols-[1fr_auto] gap-4 py-5 border-b border-white/10">
            <div className="min-w-0">
              <dt className="label">{String(i + 1).padStart(2, "0")} · {LABELS[s.key]}</dt>
              <dd className="mt-2 text-[#F5F3EE] break-words whitespace-pre-line" data-testid={`summary-${s.key}`}>{displayValue(s.key, answers) || "Não informado"}</dd>
            </div>
            <button onClick={() => onEdit(i)} data-testid={`summary-edit-${s.key}`} aria-label={`Editar ${LABELS[s.key]}`} className="grid place-items-center h-11 w-11 rounded-full border border-white/10 hover:border-[#D4AF5A]/60 transition-colors"><Pencil size={15} className="text-gold" /></button>
          </div>
        ))}
      </dl>
      <button onClick={send} data-testid="briefing-send-whatsapp" className="btn-gold mt-10 w-full h-14 rounded-full font-semibold text-[13px] tracking-[0.08em] uppercase inline-flex items-center justify-center gap-2">
        <Send size={16} /> Enviar planejamento pelo WhatsApp
      </button>
      {fallback && (
        <div data-testid="briefing-fallback" className="mt-6 rounded-2xl border border-[#D4AF5A]/30 bg-[#D4AF5A]/5 p-5 text-sm leading-relaxed">
          Seu briefing é longo demais para caber no link do WhatsApp. {copied ? "As respostas foram copiadas —" : "Copie as respostas abaixo e"} cole na conversa que abrimos. Suas respostas continuam salvas neste navegador.
        </div>
      )}
      <div className="mt-4 grid grid-cols-2 gap-3">
        <button onClick={copy} data-testid="briefing-copy" className="btn-ghost h-12 rounded-full text-sm inline-flex items-center justify-center gap-2"><Copy size={15} />{copied ? "Copiado" : "Copiar respostas"}</button>
        <button onClick={download} data-testid="briefing-download" className="btn-ghost h-12 rounded-full text-sm inline-flex items-center justify-center gap-2"><Download size={15} />Baixar .txt</button>
      </div>
      <button onClick={onReset} data-testid="briefing-reset" className="mt-6 w-full text-center text-xs text-[#A7A7AD] underline underline-offset-4 hover:text-[#F5F3EE]">Começar um novo briefing</button>
    </div>
  );
};
